module.exports = __webpack_public_path__ + "img/13.9133e86a.jpg";